export default __webpack_public_path__ + "static/media/copper_kindness.4f110484.svg";